// JQuery - Provide our own in place of what WordPress ships with. In functions.php we also dequeue the built in jquery
import './lib/JQueryGlobal';

// Some animations
(function (classlist) {
	window.addEventListener('DOMContentLoaded', function () {
		classlist.add('js-onload');
	})
	window.addEventListener('beforeunload', function () {
		classlist.add('js-unload');
	})
	window.addEventListener('pageshow', (event) => {
		if (event.persisted) {
			classlist.remove('js-unload');
		}
	});
	// window.addEventListener('pageshow', (event) => {
	// 	if (event.persisted) {
	// 		console.log('This page was restored from the bfcache.');
	// 	} else {
	// 	  console.log('This page was loaded normally.');
	// 	}
	// });
})(document.documentElement.classList);
